// extracted by css-extract-rspack-plugin
module.exports =  {"coordinate":"Draggable-PV9M__coordinate","coordinate__label":"Draggable-j00j__coordinate__label","draggable":"Draggable-KRjT__draggable"};